import angular from "angular";
import { WorkOrderDetailComponent } from "./work-order-detail.component";
import { WorkOrderDetailModalComponent } from "./work-order-detail-modal.component";
import { WorkOrderDetailContainerComponent } from "./work-order-detail-container.component";

/** A module containing components for showing details about work order details */
export const WorkOrderDetailModule = angular
    .module("apex.mainApp.workOrder.detail", [])
    .component("apexWorkOrderDetail", WorkOrderDetailComponent)
    .component("apexWorkOrderDetailContainer", WorkOrderDetailContainerComponent)
    .component("apexWorkOrderDetailModal", WorkOrderDetailModalComponent)
    .name;
